// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { ComponentType } from 'react';

import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import Browser from '@crehana/icons/pictograms/Browser';
import DownloadFile from '@crehana/icons/pictograms/DownloadFile';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { type IconProps } from '@crehana/icons/types';

import { EVENTS } from '@/views/B2BLanding/events';

import { MENU_OPTIONS } from './Header.models';

export type subItemType = {
  id: number;
  key: string;
  name: string;
  description: string;
  link: string;
  icon: ComponentType<React.PropsWithChildren<IconProps>>;
};

export type subCategoryType = {
  id: string;
  title: string;
  subItems: subItemType[];
};

export type itemDataType = {
  groups?: subCategoryType[];
  items?: subItemType[];
  link?: string;
};

type itemType = {
  id: number;
  name: string;
  type: 'items' | 'groups' | 'link';
  data: itemDataType;
};

export type DataType = {
  [key in MENU_OPTIONS]: itemType;
};

export const DATA: DataType = {
  [MENU_OPTIONS.RESOURCES]: {
    id: 3,
    name: 'HEADER_ID_3_NAME',
    type: 'items',
    data: {
      items: [
        {
          id: 3.1,
          name: 'HEADER_ID_3_ITEM_1_NAME',
          key: EVENTS.MAIN_HEADER_RESOURCES_BLOG,
          description: 'HEADER_ID_3_ITEM_1_DESCRIPTION',
          link: `${CREHANA_BASE_URL_PRD}/blog/empresas/`,
          icon: Browser,
        },
        {
          id: 3.2,
          name: 'HEADER_ID_3_ITEM_2_NAME',
          key: EVENTS.MAIN_HEADER_RESOURCES_DOWNLOADABLES,
          description: 'HEADER_ID_3_ITEM_2_DESCRIPTION',
          link: '/business/descargables/',
          icon: DownloadFile,
        },
      ],
    },
  },
};
